import { render, staticRenderFns } from "./credentialForm.vue?vue&type=template&id=36b0de65"
import script from "./credentialForm.vue?vue&type=script&lang=js"
export * from "./credentialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports